import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, Container } from 'reactstrap';
import TableContainer from '../../../components/Common/TableContainer';
import { useTranslation } from 'react-i18next';
import CoeffRelatifForm from './CoeffRelatifForm';
import { Link } from 'react-router-dom';
import { coeffAbattKmActions } from './coeffAbattKmSlice';
import { useDispatch, useSelector } from 'react-redux';

const CoeffRelatifTable = () => {
  const { t } = useTranslation('translation');

  const { coeffsKm } = useSelector(state => state.coeffAbattKm);
  const { categVH } = useSelector(state => state.data);
  const [editingItem, setEditingItem] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      dispatch(coeffAbattKmActions.listCoeffAbattKm())
    }, 2000);
  }, [])

  const handleEdit = (item) => {
    setEditingItem(item);
    console.log(item)
  };

  const columns = useMemo(() => [
    {
      Header: t('parametrage.categorie'),
      accessor: (cellProps) => {
        const categVeh = categVH.find(c => c.code === cellProps.categVeh)?.description ;
        return (
          <div>
            {categVeh}
          </div>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: t('parametrage.kmMoyAnnuelE'),
      accessor: 'kmMoyenAnnuelEs',
      disableFilters: true,
      filterable: false,
    },
    {
      Header: t('parametrage.kmMoyAnnuelH'),
      accessor: 'kmMoyenAnnuelHy',
      disableFilters: true,
      filterable: false,
    },
    {
      Header: t('parametrage.kmMoyAnnuelD'),
      accessor: 'kmMoyenAnnuelDi',
      disableFilters: true,
      filterable: false,
    },
    {
      Header: t('parametrage.coefEnPlus'),
      accessor: (cellProps) => {
        return (
          <div>
            {`${cellProps.percentValue}% / ${cellProps.percentKm} Km`}
          </div>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: t('action'),
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            <Link className="me-3 text-primary"
              onClick={() => handleEdit(cellProps)}
            >
              <i className="mdi mdi-pencil font-size-18"></i></Link>
          </React.Fragment>
        )
      },
      disableFilters: true,
      filterable: false,
    },
  ], []);

  console.log("sss" + coeffsKm)

  return (
    <React.Fragment>
      <div>
        <CoeffRelatifForm editingItem={editingItem} />
        <TableContainer
          columns={columns}
          data={coeffsKm ?? []}
          isPagination={false}
          isAddParamList={true}
          customPageSizeOptions={true}
          iscustomPageSize={false}
          isBordered={false}
          customPageSize={10}
          canDownloadtemp={true}
          isGlobalFilter={false}
          className="table-warning"

        //handleDownloadTemp={() => downloadTemp()}
        //handleUpload={uploadData}
        />
      </div>
    </React.Fragment>
  )
}


export default CoeffRelatifTable